import React, { FC } from "react";
import AdminOnly, { AdminOnlyProps } from "./AdminOnly";
import { useIsAdmin } from "../../../store/login/hooks/useSelectors";

export type ContainerProps = Omit<AdminOnlyProps, "isAdmin">;

const Container: FC<ContainerProps> = (props) => {
  const isAdmin = useIsAdmin();

  return <AdminOnly {...props} isAdmin={isAdmin} />;
};

export default Container;
